import { useEffect } from 'react';

import { fg } from '@confluence/feature-gating';
import { addUFOCustomData } from '@atlaskit/react-ufo/custom-data';
import { addUFOCustomCohortData } from '@atlaskit/react-ufo/custom-cohort-data';

import { useIsNav4Enabled } from './useIsNav4Enabled';

export const useAddUFOCustomDataForNavType = () => {
	const isNav4Enabled = useIsNav4Enabled();

	// Adds the "custom:confluence:navType" property to UFO page load event to enable
	// Nav3/Nav4 split in the performance portal. Must be called on each route as it
	// only adds custom data to the existing interaction
	useEffect(() => {
		const navType = isNav4Enabled ? 'nav4' : 'nav3';
		if (fg('platform_ufo_custom_cohort_data_migration')) {
			addUFOCustomCohortData('confluence:navType', navType);
		} else {
			addUFOCustomData({ 'confluence:navType': navType });
		}
	});
};
